import {toastError, toastSuccess} from '../vendor/SweetAlert';

export default class Easter {
    static register() {
        if (! app.games.easter.enabled) {
            return;
        }

        document.addEventListener('DOMContentLoaded', Easter.boot);
    }

    static boot() {
        const elements = document.querySelectorAll('[data-easter]');

        elements.forEach((element) => {
            element.addEventListener('click', () => {
                const value = element.getAttribute('data-easter');
                let scoreBoard = JSON.parse(localStorage.getItem('games_easter') || '[]');

                scoreBoard = [
                    ...new Set([
                        ...scoreBoard,
                        value
                    ])
                ];

                if (scoreBoard.length === 5) {
                    fetch(app.games_route, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            'name': 'easter',
                            'data': '{}'
                        })
                    })
                        .then((response) => {
                            response.json().then((data) => {
                                if (data.success) {
                                    toastSuccess(data.message);
                                } else {
                                    toastError(data.message);
                                }
                            });
                        });
                } else {
                    toastSuccess(`Bravo ! Plus que ${5 - scoreBoard.length} oeufs à trouver.`);
                }

                localStorage.setItem('games_easter', JSON.stringify(scoreBoard));
            });
        });
    }
}
